import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  StandardDesignConfig,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const AttachmentStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  RequiredToggle,
  ...StandardDesignConfig,
]
